import {
    API_REQUEST,
    GET_INCOME_UNIT_BY_ID,
    DELETE_INCOME_UNIT_BY_ID,
    RESET_GET_INCOME_BY_ID,
    RESET_DELETE_INCOME_BY_ID,
    GET_TENANT_SUMMARY_BY_SNAPSHOT_ID,
    GET_APARTMENT_TENANT_SUMMARY_BY_SNAPSHOT_ID,
    RESET_GET_TENANT_SUMMARY_BY_SNAPSHOT_ID,
    PUT_INCOME_UNIT_BY_ID,
    RESET_PUT_INCOME_UNIT,
    POST_INCOME_UNIT,
    RESET_POST_INCOME_UNIT,
    GET_INDEPENDENT_LIVING_UNITS_BY_SNAPSHOT_ID,
    GET_ASSISTED_LIVING_UNITS_BY_SNAPSHOT_ID,
    GET_MEMORY_CARE_UNITS_BY_SNAPSHOT_ID,
    GET_PREVIOUS_TENANT_SUMMARY_BY_SNAPSHOT_ID,
    RESET_GET_PREVIOUS_TENANT_SUMMARY_BY_SNAPSHOT_ID,
    GET_FULL_TENANT_SUMMARY_BY_SNAPSHOT_ID,
    RESET_GET_FULL_TENANT_SUMMARY_BY_SNAPSHOT_ID,
    SAVE_RESULT,
    RESET_APARTMENT_TENANT_SUMMARY_BY_SNAPSHOT_ID,
    RESET_INDEPENDENT_TENANT_SUMMARY_BY_SNAPSHOT_ID,
    RESET_ASSISTED_TENANT_SUMMARY_BY_SNAPSHOT_ID,
    RESET_MEMORY_TENANT_SUMMARY_BY_SNAPSHOT_ID,
    GET_UNITS_BY_SNAPSHOT_ID,
    RESET_GET_UNITS_BY_SNAPSHOT_ID,
    ROLL_DOWN_INCOME_UNIT,
    RESET_ROLL_DOWN_INCOME_UNIT
} from "../../actionTypes/actionsTypes";
import { AppAction, AsyncActionType, LocalAction } from "../../types";

export const getUnitData = (snapshotId: number | string, unitType: string): AppAction => {
    return {
        type: API_REQUEST,
        payload: {
            url: `/income/tenant-summary/${snapshotId}/${unitType}/all`,
            next: GET_UNITS_BY_SNAPSHOT_ID,
            method: 'GET',
            authorization: true
        }
    }
}

export const resetUnitData = (): LocalAction => ({
    type: RESET_GET_UNITS_BY_SNAPSHOT_ID
})

export const getTenantSummaryBySnapshotId = (snapshotId: number | string, unitType: string, isPrevious = false): AppAction => {
    let unitTypeAction: AsyncActionType = isPrevious ? GET_PREVIOUS_TENANT_SUMMARY_BY_SNAPSHOT_ID : GET_TENANT_SUMMARY_BY_SNAPSHOT_ID
    switch (unitType) {
        case '3':
            unitTypeAction = GET_APARTMENT_TENANT_SUMMARY_BY_SNAPSHOT_ID
            break;
        case '4':
            unitTypeAction = GET_INDEPENDENT_LIVING_UNITS_BY_SNAPSHOT_ID;
            break;
        case '5':
            unitTypeAction = GET_ASSISTED_LIVING_UNITS_BY_SNAPSHOT_ID;
            break;
        case '6':
            unitTypeAction = GET_MEMORY_CARE_UNITS_BY_SNAPSHOT_ID;
            break;
    }
    return {
        type: API_REQUEST,
        payload: {
            url: `/income/tenant-summary/${snapshotId}/${unitType}/all`,
            next: unitTypeAction,
            method: 'GET',
            authorization: true
        }
    }
};

export const resetIndependentTenantSummaryBySnapshotId = (): LocalAction => ({
    type: RESET_INDEPENDENT_TENANT_SUMMARY_BY_SNAPSHOT_ID
});

export const resetAssistedTenantSummaryBySnapshotId = (): LocalAction => ({
    type: RESET_ASSISTED_TENANT_SUMMARY_BY_SNAPSHOT_ID
});

export const resetMemoryTenantSummaryBySnapshotId = (): LocalAction => ({
    type: RESET_MEMORY_TENANT_SUMMARY_BY_SNAPSHOT_ID
});

export const getFullTenantSummaryBySnapshotId = (snapshotId: number | string, unitType: string): AppAction => {
    return {
        type: API_REQUEST,
        payload: {
            url: `/income/tenant-summary/${snapshotId}/${unitType}/all`,
            next: GET_FULL_TENANT_SUMMARY_BY_SNAPSHOT_ID,
            method: 'GET',
            authorization: true
        }
    }
};

export const resetGetTenantSummaryBySnapshotId = (): LocalAction => ({
    type: RESET_GET_TENANT_SUMMARY_BY_SNAPSHOT_ID
});

export const resetGetPreviousTenantSummaryBySnapshotId = (): LocalAction => ({
    type: RESET_GET_PREVIOUS_TENANT_SUMMARY_BY_SNAPSHOT_ID
});

export const resetGetFullTenantSummaryBySnapshotId = (): LocalAction => ({
    type: RESET_GET_FULL_TENANT_SUMMARY_BY_SNAPSHOT_ID
});

export const getApartmentTenantSummaryBySnapshotId = (snapshotId: number | string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/tenant-summary/${snapshotId}/3/all`,
        next: GET_APARTMENT_TENANT_SUMMARY_BY_SNAPSHOT_ID,
        method: 'GET',
        authorization: true
    }
});

export const resetApartmentTenantSummaryBySnapshotId = (): LocalAction => ({
    type: RESET_APARTMENT_TENANT_SUMMARY_BY_SNAPSHOT_ID
});

export const putIncomeUnit = (snapshotId: number | string, tenantId: string, payload: Record<string, unknown>) => ({
    type: API_REQUEST,
    payload: {
        url: `/income/${snapshotId}/save-unit/${tenantId}`,
        data: { ...payload },
        next: PUT_INCOME_UNIT_BY_ID,
        method: 'PUT',
        authorization: true
    }
})

export const putMultipleIncomeUnits = (snapshotId: number | string, units: Record<string, unknown>[]) => ({
    type: API_REQUEST,
    payload: {
        url: `/income/${snapshotId}/save-units`,
        data: { "units": units },
        next: PUT_INCOME_UNIT_BY_ID,
        method: 'PUT',
        authorization: true
    }
})

export const resetPutIncomeUnit = (): LocalAction => ({
    type: RESET_PUT_INCOME_UNIT
})


export const postIncomeUnit = (snapshotId: number | string, payload: Record<string, unknown>) => ({
    type: API_REQUEST,
    payload: {
        url: `/income/${snapshotId}/add-unit`,
        data: { ...payload },
        next: POST_INCOME_UNIT,
        method: 'POST',
        authorization: true
    }
})

export const postMultipleIncomeUnits = (snapshotId: number | string, units: Record<string, unknown> | Record<string, unknown>[], type: string) => ({
    type: API_REQUEST,
    payload: {
        url: `/income/${snapshotId}/add-units`,
        data: { "units": units, "type": type },
        next: POST_INCOME_UNIT,
        method: 'POST',
        authorization: true
    }
})

export const resetPostIncomeUnit = (): LocalAction => ({
    type: RESET_POST_INCOME_UNIT
})

// Manage unit income action
export const getIncomeUnitById = (snapshotId: string | number, unitId: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/${snapshotId}/get-unit/${unitId}`,
        next: GET_INCOME_UNIT_BY_ID,
        method: 'GET',
        authorization: true
    }
});

export const resetGetIncomeUnitById = (): LocalAction => ({
    type: RESET_GET_INCOME_BY_ID
});


export const deleteIncomeUnitById = (snapshotId: string | number, unitId: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/${snapshotId}/unit/${unitId}`,
        next: DELETE_INCOME_UNIT_BY_ID,
        method: 'DELETE',
        authorization: true
    }
});

export const deleteMultipleIncomeUnitsByIds = (snapshotId: number | string, unitIds: number[]) => ({
    type: API_REQUEST,
    payload: {
        url: `/income/${snapshotId}/units`,
        data: { "units": unitIds },
        next: DELETE_INCOME_UNIT_BY_ID,
        method: 'DELETE',
        authorization: true
    }
})

export const upsertBatchIncomeUnits = (snapshotId: number | string, payloadData: Record<string, unknown>): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/${snapshotId}/upsert-units`,
        data: {
            ...payloadData
        },
        next: SAVE_RESULT,
        method: 'POST',
        authorization: true
    }
})

export const upsertRHOResidential = (snapshotId: number | string, payloadData: Record<string, unknown>): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/${snapshotId}/upsert-rho-residential`,
        data: {
            ...payloadData
        },
        next: SAVE_RESULT,
        method: 'POST',
        authorization: true
    }
})

export const rollDownIncomeUnits = (snapshotId: number | string, payloadData: Record<string, unknown>): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/${snapshotId}/roll-down-units`,
        data: {
            ...payloadData
        },
        next: ROLL_DOWN_INCOME_UNIT,
        method: 'POST',
        authorization: true
    }
})

export const resetRollDownIncomeUnits = (): LocalAction => ({
    type: RESET_ROLL_DOWN_INCOME_UNIT
});

export const resetDeleteIncomeUnitById = (): LocalAction => ({
    type: RESET_DELETE_INCOME_BY_ID
});
